import { Sun, Moon } from 'lucide-react';
import { useTheme } from '@/src/contexts/ThemeContext';

interface ThemeToggleProps {
  /** Positions itself fixed in the top-right of the viewport (used on full-screen views like SignIn). */
  fixed?: boolean;
  className?: string;
}

export default function ThemeToggle({ fixed, className }: ThemeToggleProps) {
  const { isDark, toggleTheme } = useTheme();

  return (
    <button
      type="button"
      onClick={toggleTheme}
      aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      className={[
        fixed ? 'fixed z-50' : '',
        'w-9 h-9 rounded-full flex items-center justify-center transition-colors',
        className ?? '',
      ].join(' ')}
      style={{
        // On iPhone, sit below the status bar / Dynamic Island instead of under it.
        // env() values are 0 on the web, so this matches the old top-5 right-5 there.
        ...(fixed ? {
          top: 'calc(1.25rem + env(safe-area-inset-top, 0px))',
          right: 'calc(1.25rem + env(safe-area-inset-right, 0px))',
        } : {}),
        background: isDark ? 'rgba(255,255,255,0.06)' : 'rgba(0,0,0,0.05)',
        border: `1px solid ${isDark ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.08)'}`,
        color: isDark ? 'rgba(255,255,255,0.7)' : '#6E6E64',
      }}
    >
      {isDark ? <Sun size={16} /> : <Moon size={16} />}
    </button>
  );
}